import React from "react";
import { Link } from "react-router-dom";
import TypewriterComponent from "typewriter-effect";

const Projects = ({ project }) => {
  const {
    title,
    description,
    img,
    live_site,
    client_code,
    tech1,
    tech2,
    tech3,
    tech4,
  } = project;
  return (
    <div className="mx-auto max-w-sm rounded-lg overflow-hidden shadow-lg bg-gray-900 text-white">
      <div className="relative">
        <img src={img} alt="websites" className="w-full" />
        <div className="absolute inset-0 bg-black opacity-50 transition-opacity"></div>
      </div>
      <div className="px-6 py-4">
        <h2 className="text-2xl font-semibold mb-2">{title}</h2>
        <div className="flex space-x-2">
          <div className="badge bg-blue-600 py-1 px-2 rounded-md text-white">
            {tech1}
          </div>
          <div className="badge bg-green-600 py-1 px-2 rounded-md text-white">
            {tech2}
          </div>
          <div className="badge bg-indigo-600 py-1 px-2 rounded-md text-white">
            {tech3}
          </div>
        </div>
        <p className="mt-4 text-gray-300">{description}</p>
      </div>
      <div className="px-6 py-4 flex justify-between">
        <a href={live_site} className="work_button">
          <button className="btn bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
            <span className="text-lg">Live link</span>
          </button>
        </a>
        <a href={client_code}>
          <button className="btn bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded">
            <span className="text-lg">Code link</span>
          </button>
        </a>
      </div>
    </div>
  );
};

export default Projects;
